import React from 'react'
import { Document } from '@contentful/rich-text-types'
import { AutoHighlightResult } from 'highlight.js'
import hljs from 'highlight.js/lib/core'
import html from 'highlight.js/lib/languages/xml'
import javascript from 'highlight.js/lib/languages/javascript'
import css from 'highlight.js/lib/languages/css'
import python from 'highlight.js/lib/languages/python'
import Head from 'next/head'
import { useInView } from 'react-intersection-observer'

import { LibraryPostBlockBase } from '../types'
import Caption from '../Caption'

import { Wrapper, Code } from './styles'

type Language = 'xml' | 'javascript' | 'css' | 'python'

hljs.registerLanguage('xml', html)
hljs.registerLanguage('javascript', javascript)
hljs.registerLanguage('css', css)
hljs.registerLanguage('python', python)

export type LibraryPostBlockCode = LibraryPostBlockBase<
  'libraryPostBlockCode',
  {
    // caption: Document;
    content: string
    language?: Language
  }
>

type Props = {
  caption?: Document
  children: string
  language?: Language
}

const LibraryPostBlockCode = ({ caption, language, children }: Props) => {
  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  })

  const code = React.useMemo<AutoHighlightResult | null>(
    () => (inView ? hljs.highlightAuto(children, language ? [language] : ['javascript']) : null),
    [language, children, inView],
  )

  return (
    <>
      <Head>
        <link
          key="highlight.js-css"
          id="highlight.js-css"
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/highlight.js/10.7.2/styles/github.min.css"
          integrity="sha512-7QTQ5Qsc/IL1k8UU2bkNFjpKTfwnvGuPYE6fzm6yeneWTEGiA3zspgjcTsSgln9m0cn3MgyE7EnDNkF1bB/uCw=="
          crossOrigin="anonymous"
        />
      </Head>
      <Wrapper ref={ref}>
        <pre>
          {/* @ts-expect-error Will need to improve this on the design */}
          <Code dangerouslySetInnerHTML={code?.value ? { __html: code.value } : undefined}>
            {code?.value ? null : children}
          </Code>
        </pre>
        {caption && <Caption>{caption}</Caption>}
      </Wrapper>
    </>
  )
}

export default LibraryPostBlockCode
